import { useSuspenseQuery } from '@tanstack/react-query'

import { useParamOrFail } from '@/hooks/useParamOrFail'
import { PARAMS } from '@/lib/params'
import { QUERY_KEYS } from '@/lib/queryKeys'
import referralService from '@/lib/services/referralService'

export function useReferralInvitesQuery() {
  const token = useParamOrFail(PARAMS.referralInvites.token)

  return useSuspenseQuery({
    queryKey: QUERY_KEYS.referralInvites({ token }),
    queryFn: () => referralService.getReferralInvites({ token, pageSize: 6 }),
    staleTime: 30000,
    retry: false,
  })
}
